interface GlyphProps {
  key: string;
  path: string;
  caption: string;
  color?: string;
  isSingleGlyph?: boolean;
  viewBox?: string;
}

export const Glyph: React.FC<GlyphProps> = ({
  key,
  path,
  caption,
  color,
  isSingleGlyph = false,
  viewBox,
}) => {
  return (
    <div
      key={key}
      style={{
        width: "150px",
        height: "100%",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          backgroundColor: color || "#eee",
          borderRadius: "5px",
          padding: "20px",
        }}
      >
        <svg viewBox={viewBox} width="100%" height="100%">
          <path d={path} fill={isSingleGlyph ? "#ccc" : "#000"} />
        </svg>
      </div>
      <div
        style={{
          marginTop: "10px",
          fontSize: "10px",
          color: "#000",
          fontWeight: "bolder",
          textAlign: "center",
        }}
      >
        {caption}
      </div>
    </div>
  );
};
